import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContentPreviewComponent } from './content-preview.component';
import {FormsModule} from '@angular/forms';
import {GenericModalModule} from '../../modal/generic-modal.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        GenericModalModule
    ],
  declarations: [ContentPreviewComponent],
  providers: [],
  exports: [ContentPreviewComponent]
})

export class ContentPreviewModule {

}
